const { fontExceptionsLanguageList } = require('LoadConfig');
const PSEvents = require('PSEvents');
const PSConfig = require('PSConfig');

cc.Class({
    extends: cc.Component,

    properties: {
        font: cc.Font
    },

    editor: {
        requireComponent: cc.Label,
    },
    
    onLoad () {
        if (!fontExceptionsLanguageList || !fontExceptionsLanguageList.length) {
            return;
        }

        PSEvents.onEngineInitialized(() => {
            const { language } = PSConfig.get();

            if (fontExceptionsLanguageList.includes(language)) {
                const label = this.getComponent(cc.Label);
                label.font = this.font;
            }
        });
    }
});
